import moment from 'moment'
import {
  IAbsence,
  IAPIAbsence,
  IAPIWorkingSchedule,
} from '../interface/IWorkingSchedule'

const absencesMap = (
  absences: IAPIAbsence[],
  personId: number,
): IAbsence[] => absences.map((absence) => ({
  id: absence.id,
  beginsAt: moment(absence.begins_at, 'YYYY-MM-DD HH:mm:ss'),
  endsAt: moment(absence.ends_at, 'YYYY-MM-DD HH:mm:ss'),
  personId,
}))

export const absenceTransformer = (
  data: IAPIWorkingSchedule,
): IAbsence[] => {
  const personIds = Object.keys(data)

  return personIds.map((personId) => {
    const personAbsences = data[personId].absences
    return absencesMap(personAbsences, Number(personId))
  }).flat()
}
